import React from 'react';
var PlanPill = function PlanPill(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-pill-row d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pricing-pill rounded-pill fw-medium text-nowrap flex-shrink-0"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "pricing-pill-rule flex-grow-1"
  }));
};
export default PlanPill;